import React from 'react';

function NotesPageSideBar({ notesAuthor, setNotesAuthor }) {
  const className = (author) =>
    `general-button rounded-pill specific-y-padding-13 ${
      notesAuthor === author ? 'action-button' : 'border-general bg-main-white border-grey action-state-hover'
    }`;

  return (
    <div className='d-flex flex-column gap-20'>
      <button
        className={className('my-own')}
        onClick={() => {
          setNotesAuthor('my-own');
        }}
      >
        My notes
      </button>
      <button
        className={className('my-teams')}
        onClick={() => {
          setNotesAuthor('my-teams');
        }}
      >
        My team's notes
      </button>
    </div>
  );
}

export default NotesPageSideBar;
